export default "__VITE_ASSET__CcL9jin$__"